export default __webpack_public_path__ + "static/media/btcpay_logo.6dee105b.png";